import { profile } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

export const usePayouts = (params, options) => {
	const response = useQuery({
		queryKey: ['payouts', params?.page], 
		queryFn: () => profile.getAllPayouts(params), 
		select: (data) => data.data,
		...options
	})

	return response
}